import { MultiStepEditSection } from "components/MainSectionTemplate/MultiStepEditSectionTemplate";
import ArtistModalPicker from "components/Picker/ArtistPicker/ArtistModalPicker";
import React from "react";
import { GoogleCalendarFormState, NewExternalCalendarStep } from "./model";

export const googleCalendarConfigureSection = (
  googleCalendarFormState: GoogleCalendarFormState,
  setGoogleCalendarFormState: (state: GoogleCalendarFormState) => void,
): MultiStepEditSection<NewExternalCalendarStep> => ({
  getNextSection: () => null,
  getPrevSection: () => "googleCalendarConnect",
  isLastStep: () => true,
  sectionSteps: [{
    title: RESX.ConnectedAccount.Connect,
    isActive: false,
  }, {
    title: RESX.GeneralLabels.Configure,
    isActive: true,
  }],
  section: {
    type: "regular",
    key: "googleCalendarConfigure",
    title: RESX.ExternalCalendar.NewExternalCalendar,
    fields: [{
      key: "type",
      label: RESX.GeneralLabels.Type,
      renderEditNew: () => <div className="main-section-template-fields-padding">
        Google Calendar
      </div>,
    }, {
      key: "name",
      label: RESX.GeneralLabels.Name,
      renderEditNew: () => <div className="main-section-template-fields-padding">
        {googleCalendarFormState.name}
      </div>,
    }, {
      key: "eventCount",
      label: RESX.ExternalCalendar.ExternalEvents,
      renderEditNew: () => <div className="main-section-template-fields-padding">
        {googleCalendarFormState.eventCount}
        <div className="s1_small s1_gray">
          {RESX.ExternalCalendar.AppoinmentsFurtherInTheFutureThanXMonthsAreDiscarded.replace("{0}", serverReference.constants.externalCalendar.defaultMonthsInFuture.toString())}
        </div>
        <div className="s1_small s1_gray">
          {RESX.ExternalCalendar.AppointmentsOlderThanXMonthsAreDiscarded.replace("{0}", serverReference.constants.externalCalendar.defaultMonthsInPast.toString())}
        </div>
      </div>,
    }, {
      key: "artist",
      label: site.currentEnvironment.functionGroups.artist.singular,
      renderEditNew: () => <div className="main-section-template-fields-padding">
        <ArtistModalPicker
          canCreateNew={false}
          securityScope="limitByUserAccess"
          nonInPageEditing={{
            onChange: a => setGoogleCalendarFormState({ ...googleCalendarFormState, artist: a }),
            value: googleCalendarFormState.artist,
            required: true,
            validatorKey: "artist",
          }}
        />
      </div>
    }]
  }
});